export default __webpack_public_path__ + "static/media/icon-feather-alert-triangle.5f2b06b7.svg";